import { useState } from "react";
import { toggleArrayItem } from "@zyzgroup/core-common";

export function useSelection<T>(items: T[]) {
  const [selected, setSelected] = useState<T[]>(items);
  const toggle = (item: T) => {
    setSelected((list) => toggleArrayItem(list, item));
  };
  return { selected, toggle };
}
